// extracted by mini-css-extract-plugin
export default {"container":"Af_nzG","svg":"zUowUt","circle":"Lm4lqU","bar":"L4UccY","completeIcon":"pSSpOZ"};